import { render } from "./ModifyPassword.vue?vue&type=template&id=76a34baf&ts=true"
import script from "./ModifyPassword.vue?vue&type=script&lang=ts"
export * from "./ModifyPassword.vue?vue&type=script&lang=ts"

import "./ModifyPassword.vue?vue&type=style&index=0&id=76a34baf&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ModifyPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76a34baf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76a34baf', __exports__)) {
    console.log('reload')
    api.reload('76a34baf', __exports__)
  }
  
  module.hot.accept("./ModifyPassword.vue?vue&type=template&id=76a34baf&ts=true", () => {
    console.log('re-render')
    api.rerender('76a34baf', render)
  })

}


export default __exports__